<template>
  <div>
    <div class="container-fluid" style="zoom: 80%">
      <div class="row">
        <div class="col-md-12 mb-2">
          <h3 style="font-weight:700">Account Settings</h3>
        </div>
        <Sidebar />
        <div class="col-md-10 pl-0" v-if="status">
          <div class="card card-box mb-3 " style="border-radius : 0%; height: 97.5%;">
            <div class="card-body">
              <b-form>
                <div class="row">
                  <div class="col-md-12 mt-2 mb-3">
                    <h4 class="__blue" style="font-weight: 700">
                      Bridging BPJS
                    </h4>
                  </div>
                  <div class="col-md-8">
                    <b-form-group
                      id="fieldset-horizontal"
                      label-cols-sm="4"
                      label-cols-lg="4"
                      content-cols-sm
                      content-cols-lg="8"
                      label="Username PCare:"
                      label-for="input-horizontal"
                    >
                      <b-form-input
                        id="input-horizontal"
                        :disabled="btnDisable"
                        placeholder="Tulis Username PCare"
                        v-model="form.pcare_username"
                      ></b-form-input>
                    </b-form-group>
                    <b-form-group
                      id="fieldset-horizontal"
                      label-cols-sm="4"
                      label-cols-lg="4"
                      content-cols-sm
                      content-cols-lg="8"
                      label="Password PCare:"
                      label-for="input-horizontal"
                    >
                      <b-form-input
                        id="input-horizontal"
                        :disabled="btnDisable"
                        placeholder="Tulis Password PCare"
                        v-model="form.pcare_password"
                      ></b-form-input>
                    </b-form-group>
                    <b-form-group
                      id="fieldset-horizontal"
                      label-cols-sm="4"
                      label-cols-lg="4"
                      content-cols-sm
                      content-cols-lg="8"
                      label="Kode PPK:"
                      label-for="input-horizontal"
                    >
                      <b-form-input
                        id="input-horizontal"
                        :disabled="btnDisable"
                        placeholder="Tulis Kode PPK"
                        v-model="form.kdprovider"
                      ></b-form-input>
                    </b-form-group>
                    <b-form-group
                      id="fieldset-horizontal"
                      label-cols-sm="4"
                      label-cols-lg="4"
                      content-cols-sm
                      content-cols-lg="8"
                      label="ConsID:"
                      label-for="input-horizontal"
                    >
                      <b-form-input
                        id="input-horizontal"
                        :disabled="btnDisable"
                        placeholder="Tulis Cons ID"
                        v-model="form.cons_id"
                      ></b-form-input>
                    </b-form-group>
                    <b-form-group
                      id="fieldset-horizontal"
                      label-cols-sm="4"
                      label-cols-lg="4"
                      content-cols-sm
                      content-cols-lg="8"
                      label="Secret Key:"
                      label-for="input-horizontal"
                    >
                      <b-form-input
                        id="input-horizontal"
                        :disabled="btnDisable"
                        placeholder="Tulis Secret Key"
                        v-model="form.cons_secret"
                      ></b-form-input>
                    </b-form-group>
                    <b-form-group
                      id="fieldset-horizontal"
                      label-cols-sm="4"
                      label-cols-lg="4"
                      content-cols-sm
                      content-cols-lg="8"
                      label="Kode Aplikasi:"
                      label-for="input-horizontal"
                    >
                      <b-form-input
                        id="input-horizontal"
                        :disabled="btnDisable"
                        placeholder="Tulis Kode Aplikasi"
                        v-model="form.kdaplikasi"
                      ></b-form-input>
                    </b-form-group>
                    <b-form-group
                      id="fieldset-horizontal"
                      label-cols-sm="4"
                      label-cols-lg="4"
                      content-cols-sm
                      content-cols-lg="8"
                      label="User Key:"
                      label-for="input-horizontal"
                    >
                      <b-form-input
                        id="input-horizontal"
                        :disabled="btnDisable"
                        placeholder="Tulis User Key"
                        v-model="form.user_key"
                      ></b-form-input>
                    </b-form-group>
                  </div>
                  <div class="col-md-8">
                    <b-alert show variant="dark" class="alert-bridging-bpjs">
                      <p>Prosedur Bridging BPJS:</p>
                      <p class="p-bridging-bpjs">- Pihak Fasilitas Kesehatan koordinasi dengan kantor cabang BPJS setempat untuk melakukan bridging BPJS</p>
                      <p class="p-bridging-bpjs">- Pihak Fasilitas Kesehatan memenuhi syarat dan ketentuan untuk melakukan bridging BPJS</p>
                      <p class="p-bridging-bpjs">- Pihak Fasilitas Kesehatan mendapatkan cons ID - Secret Key</p>
                      <p class="p-bridging-bpjs">- Pihak Fasilitas Kesehatan mengisi cons ID - Secret Key di profil izidok</p>
                    </b-alert>
                  </div>
                  <div class="col-md-12 mt-5 mb-3">
                    <b-button
                      variant="primary"
                      v-if="!btnDisable"
                      class="float-right"
                      @click="onSubmit"
                      >SIMPAN</b-button
                    >
                    <b-button
                      variant="primary"
                      v-if="btnDisable"
                      @click="btnDisable = false"
                      class="float-right"
                      >EDIT DATA</b-button
                    >
                  </div>
                </div>
              </b-form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal
      ref="__modal_loading"
      hide-header
      hide-footer
      no-close-on-esc
      centered
      no-close-on-backdrop
      content-class="shadow-none modal_loading"
      size="xs"
    >
      <b-row>
        <b-col sm="12" class="text-center">
          <div class="spinner-border text-warning mb-5" role="status">
            <span class="sr-only">Loading...</span>
          </div>
          <p>Mohon Menunggu <br> Sedang melakukan proses konfigurasi</p>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  components: {
    Sidebar: () => import("@/views/AccountSettingKlinik/Sidebar"),
  },
  data: () => {
    return {
      status: false,
      btnDisable: true,
      form: {
        pcare_username: null,
        pcare_password: null,
        kdprovider: null,
        cons_id: null,
        cons_secret: null,
        kdaplikasi: null,
        user_key: null,
      },
    };
  },
  mounted() {
    this.fetchData()

    window.scrollTo({
      top: 95,
      behavior: "smooth"
    });
  },
  computed: {
    ...mapGetters(["getKlinikId"])
  },
  methods: {
    onSubmit() {
      const swalWithBootstrapButtons = this.$swal.mixin({
        customClass: {
          confirmButton: 'btn btn-info',
          cancelButton: 'btn btn-danger mr-2'
        },
        buttonsStyling: false,
      });

      swalWithBootstrapButtons.fire({
        type: "warning",
        html: '<p class="m-0 text-bridging-bpjs">Apakah Anda yakin akan <br> melakukan Bridging BPJS?</p>',
        showCancelButton: true,
        confirmButtonText: 'Ya',
        cancelButtonText: 'Tidak',
        reverseButtons: true,
      }).then((res) => {
        if (res.value) {
          this.btnDisable = true;
          this.submit();
        }
      });
    },
    async submit() {
      this.$refs["__modal_loading"].show();
      const res = await this.$axios.put(`bpjs/auth?klinik_id=${this.getKlinikId}`, this.form);
      const { status } = res.data;
      this.$refs["__modal_loading"].hide();
      if (status) {
        const resKhusus = await this.$axios.get(`bpjs/referensi-khusus?klinik_id=${this.getKlinikId}`);
        const khusus = resKhusus.data;
        if (khusus) {
          if (khusus.response.list.length > 0) {
            this.$store.commit("SET_BPJS_AUTH_VALID", 0);
            this.$swal({
              type: "success",
              html: '<p class="m-0 text-bridging-bpjs">Bridging BPJS berhasil!</p>',
            });
          } else {
            this.btnDisable = false;
            this.$swal({
              type: "error",
              html: '<p class="m-0 text-bridging-bpjs">Bridging BPJS gagal! <br> Mohon cek kembali data konfigurasi atau hubungi PIC kantor cabang BPJS Anda!</p>',
            });
          }
        }
      } else {
        this.btnDisable = false;
        this.$swal({
          type: "error",
          html: '<p class="m-0 text-bridging-bpjs">Bridging BPJS gagal! <br> Mohon cek kembali data konfigurasi atau hubungi PIC kantor cabang BPJS Anda!</p>',
        });
      }
    },
    async fetchData() {
      try {
        const res = await this.$axios.get( `bpjs/auth?klinik_id=${this.getKlinikId}`);
        const { status, data } = res.data;
        if (status) {
          if (data.bpjs_auth_valid) {
            this.form = {
              pcare_username: data.bpjs_pcare_username,
              pcare_password: data.bpjs_pcare_password,
              kdprovider: data.bpjs_kdprovider,
              cons_id: data.bpjs_cons_id,
              cons_secret: data.bpjs_cons_secret,
              kdaplikasi: data.bpjs_kdaplikasi,
              user_key: data.bpjs_user_key,
            }
          }
          this.status = true;
        }
      } catch (e) {}
    },
  }
};
</script>

<style>
  .col-form-label {
    margin-bottom: 20px;
  }
  .text-bridging-bpjs {
    font-size: 14px;;
  }
  .modal_loading .modal-header {
    background-color: #ffffff;
  }
  .modal-backdrop {
    opacity: 0.5 !important;
  }
</style>

<style scoped>
  .__blue {
    color: #4b80b6;
  }
  .alert {
    border-radius: 5px;
  }
  .alert-radio-label {
    padding: 0.75rem 2rem;
    margin-right: 50px;
  }
  .alert-bridging-bpjs {
    background-color: #eeeff8;
    opacity: 1;
    top: -10px;
  }
  .p-bridging-bpjs {
    margin: 0;
  }
  .spinner-border {
    width: 5em;
    height: 5em;
  }
</style>